import React, { useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Input } from "reactstrap";
import withRedirect from "../../hoc/withRedirect";
import authenticationService from "../../services/authenticationService";
import useFullPageLoader from "../../hooks/useFullPageLoader";

const ForgetPasswordForm = ({
  setQuestions,
  setShowSecurityQuestion,
  setIsResetPasswordActive,
  email, 
  setEmail, 
  setRedirect,
  setRedirectUrl,
  layout,
}) => {
  // const [email, setEmail] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
    ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
    : false;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;

    showLoader();
    let body = { email: email};
    sessionStorage.setItem("SaveEmailID", email);

     authenticationService
      .forgetPassword("forgot_password_email_verify", body)
      .then((res) => {
        toast.success(res.data.message);
        sessionStorage.setItem("devid", res.data.devid);

        
        authenticationService
              
               .Get2FAQuestions("forgot_password_garq", { username: email})
              .then((response) => {
              
                if (!response.data.items.length == 0) {

                  setQuestions(response.data.items);
                  setShowSecurityQuestion(true); 
                } else {
                  setIsResetPasswordActive(true);
                }
                hideLoader();
              })
          .catch(() => {
            toast.error("Failed to fetch security questions.");
            hideLoader();
          });
      })
      .catch((error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        hideLoader();
      });
  };

  return (
    <>
      <Form
        style={{ minWidth: "300px", maxWidth: "600px" }}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <FormGroup>
          <Input
            className="form-control"
            placeholder="Email address"
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            type="email"
            required
          />
        </FormGroup>
        <FormGroup>
          <Button
            color={isApiPlusExist ? "" : "primary"}
            className={'${isApiPlusExist && "sai_button"}'}
            block
            disabled={!email}
          >
            Verify
          </Button>
        </FormGroup>
      </Form>
      {loader}
    </>
  );
};

ForgetPasswordForm.propTypes = {
  setQuestions: PropTypes.func.isRequired,
  setShowSecurityQuestion: PropTypes.func.isRequired,
  setRedirect: PropTypes.func,
  setRedirectUrl: PropTypes.func,
  layout: PropTypes.string,
};

ForgetPasswordForm.defaultProps = { layout: "basic" };

export default withRedirect(ForgetPasswordForm);